export const palette = {
  brandBlue: '#7366FF',
  brandBlue10: '#f1f0ff',
  brandPink: '#FF6CAB',
  errorRed: '#FE8B8D',
  errorRedDark: '#F43F5E',
  greenSuccessLight: '#F0FDF5',
  greenSuccess: '#16A34A',
  blueInfoLight: '#EFF5FF',
  blueInfo: '#3B82F6',
  yellowWarningLight: '#FEFAE8',
  yelloWarning: '#FACC15',
  archivedLight: '#F6F6F6',
  archived: '#9E9E9E',
  gray: '#F8F7FF',
  white: '#ffffff',
  black: '#121212',
  stroke: '#E9ECF1',
  secondaryBlack5: '#4A4E5E',
  nuetral4: '#717998',
  analytics10: '#DFDDF5',
  analytics20: '#B7B1F7',
  analytics30: '#8F85FD',
  analytics40: '#5646FF',
  nuetral4Placeholder: '#A9AEC3',
  neutralN400: '#A4AFC1',
  neutralN300: '#BFC8D4',
  neutralN500: '#8D97B0',
  neutralN700: '#62667F',
  blue600: '#2563EB',
  primaryP600: '#8347E0',
  brandDarkGray: '#888888',
  revoke: '#074C75',
  brandPurple: '#B961FF',
};
